<template>
    <VDropdown>
        <div class="flex items-center justify-center cursor-pointer">
            <slot />
        </div>

        <template #popper="{ hide }">
            <div class="bg-[white]">
                <div
                    v-for="option of options"
                    :key="option.value"
                    class="pointer h-6 px-2.5 flex items-center cursor-pointer hover:won-tag-light-gray hover:bg-won-bg-blue"
                    @click="handleSelect(option, hide)"
                >
                    <component :is="option.icon" class="size-3 text-won-blue"/>
                    <div :class="['ml-1 won-blue text-xs', itemClass]">
                        {{ option.label }}
                    </div>
                </div>
            </div>
        </template>
    </VDropdown>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        itemClass: {
            type: String,
            default: "",
        },
    },

    emits: ["menu-dropdown:select"],

    methods: {
        handleSelect(option, hide) {
            this.$emit("menu-dropdown:select", option);

            hide?.();
        },
    },
};
</script>
